import { render, staticRenderFns } from "./SeguroEntradasSinNumerarComponent.vue?vue&type=template&id=0bc929f0"
import script from "./SeguroEntradasSinNumerarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SeguroEntradasSinNumerarComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports